"use client";

import { useEffect } from "react";
import { track } from "@/lib/tracking/track";
import type { AnalyticsEventName, AnalyticsEvents } from "@/lib/tracking/events";

// Para páginas de servidor: manda un evento al abrirse (event_view,
// movie_view...). `id` identifica la página: el evento se repite solo si
// cambia (no en cada render).
export function TrackOnMount<N extends AnalyticsEventName>({
  name,
  params,
  id,
}: {
  name: N;
  params: AnalyticsEvents[N];
  id: string;
}) {
  useEffect(() => {
    track(name, params);
    // Solo `id`: params es un objeto nuevo en cada render del padre.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, id]);
  return null;
}
